import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface UnsavedChangesDialogProps {
  onDiscard: () => void;
  onSaveAndExit: () => void;
  onCancel: () => void;
}

export function UnsavedChangesDialog({
  onDiscard,
  onSaveAndExit,
  onCancel,
}: UnsavedChangesDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog open onOpenChange={(open) => !open && onCancel()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-start gap-4 mb-2">
            <div className="w-12 h-12 bg-yellow-500/10 rounded-full flex items-center justify-center flex-shrink-0">
              <AlertTriangle className="text-yellow-600 dark:text-yellow-500" size={24} />
            </div>
            <div className="flex-1 space-y-2">
              <DialogTitle className="text-left">
                {t('unsavedChangesDialog.title')}
              </DialogTitle>
              <DialogDescription className="text-left">
                {t('unsavedChangesDialog.description')}
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>

        <div className="flex gap-3 mt-4">
          <Button
            onClick={onCancel}
            variant="outline"
            className="flex-1"
          >
            {t('unsavedChangesDialog.continueEditing')}
          </Button>
          <Button
            onClick={onDiscard}
            variant="outline"
            className="flex-1 text-destructive hover:bg-destructive/10"
          >
            {t('unsavedChangesDialog.discard')}
          </Button>
          <Button
            onClick={onSaveAndExit}
            className="flex-1"
          >
            {t('unsavedChangesDialog.saveAndExit')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
